export type GovernedPdfCanvasRenderTask = {
  promise: Promise<void>;
  cancel: () => void;
};

export function isGovernedPdfRenderCancellation(error: unknown): boolean {
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return (
      error.name === "RenderingCancelledException" ||
      message.includes("rendering cancelled") ||
      message.includes("cancelled") ||
      message.includes("same canvas during multiple render")
    );
  }
  if (typeof error === "object" && error !== null && "name" in error) {
    const name = String((error as { name: unknown }).name);
    const message =
      "message" in error ? String((error as { message: unknown }).message) : "";
    return (
      name === "RenderingCancelledException" ||
      message.toLowerCase().includes("rendering cancelled") ||
      message.toLowerCase().includes("cancelled")
    );
  }
  return false;
}

export function runGovernedPdfCanvasRenderTask(input: {
  startRender: () => GovernedPdfCanvasRenderTask;
  isStale: () => boolean;
  onComplete: () => void;
  onError: (error: unknown) => void;
}): () => void {
  let activeTask: GovernedPdfCanvasRenderTask | null = null;
  let cancelled = false;

  activeTask = input.startRender();
  void activeTask.promise
    .then(() => {
      if (!cancelled && !input.isStale()) {
        input.onComplete();
      }
    })
    .catch(error => {
      if (
        !cancelled &&
        !input.isStale() &&
        !isGovernedPdfRenderCancellation(error)
      ) {
        input.onError(error);
      }
    });

  return () => {
    cancelled = true;
    activeTask?.cancel();
  };
}

export function scrollGovernedPdfDocumentPaneToPage(input: {
  scrollRoot: HTMLElement;
  pageElement: HTMLElement;
  behavior?: ScrollBehavior;
}): void {
  input.scrollRoot.scrollTo({
    top: input.pageElement.offsetTop,
    behavior: input.behavior ?? "auto",
  });
}

export function scrollGovernedPdfThumbnailRailToElement(input: {
  railRoot: HTMLElement;
  targetElement: HTMLElement;
}): void {
  const nextTop =
    input.targetElement.offsetTop -
    input.railRoot.clientHeight / 2 +
    input.targetElement.clientHeight / 2;
  input.railRoot.scrollTop = Math.max(0, nextTop);
}
